import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

import { CheckableColumnComponent } from '@shared/components/table/checkable-column/checkable-column.component';

@NgModule({
  declarations: [CheckableColumnComponent],
  imports: [CommonModule, MatCheckboxModule, MatTableModule],
  exports: [CheckableColumnComponent],
})
export class CheckableColumnModule {}
